const state = {
  tradePlanList: [],
  tradePlan: {
    tradePlanNo: undefined,
    headerForm: {},
  },
  tradePlanDetail: [],
  budgetHeadGridData: {
    budgetCategory: null,
    budgetType: null,
  },
  budgetHeadList: [],
  salesDetails:[],
  salesDeductionPlan:[],
  planDetailList: [],
  netSalesList: [],
  budgetHeadObject: {},
};
export default state;
